import { render, staticRenderFns } from "./ReportesInforme.vue?vue&type=template&id=06ef348c&scoped=true&"
import script from "./ReportesInforme.vue?vue&type=script&lang=js&"
export * from "./ReportesInforme.vue?vue&type=script&lang=js&"
import style0 from "./ReportesInforme.vue?vue&type=style&index=0&id=06ef348c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef348c",
  null
  
)

export default component.exports